import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const KEY = "claira-cookie-notice-dismissed";

/**
 * Minimal cookie notice for the landing page.
 *
 * Claira only sets strictly-necessary Stripe cookies on payment pages, so a
 * full consent management platform would be misleading (it would imply there
 * are optional cookies). This bar is informational only — no Accept/Decline.
 */
export function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch { /* localStorage unavailable — show by default */ setVisible(true); }
  }, []);

  if (!visible) return null;

  function dismiss() {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setVisible(false);
  }

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border border-border/60 bg-background/95 p-3 shadow-soft backdrop-blur safe-bottom md:inset-x-auto md:left-1/2 md:-translate-x-1/2 md:bottom-4"
    >
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-muted-foreground leading-relaxed">
          We use essential cookies for secure payment processing only. No tracking. No advertising.{" "}
          <Link to="/cookie-policy" className="text-primary underline">Learn more</Link>.
        </p>
        <div className="shrink-0">
          <Button size="sm" onClick={dismiss}>Got it</Button>
        </div>
      </div>
    </div>
  );
}